let e;
function n() {
  return e === void 0 && (e = navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")), e;
}
export {
  n as isJsdom
};
